export const NAV_LABELS = {
  menu: "Menu",
  account: "Account",
  accountHome: "Account Home",
  energyUsage: "Energy Usage",
  billsAndTransactions: "Bills & Transactions",
  payments: "Payments",
  tariff: "Tariff Details",
  tariffDetails: "Tariff details",
  personalDetails: "Personal Details",
  referAFriend: "Refer a Friend",
  meterReadings: "Meter Readings",
  movingHome: "Moving Home",
  aboutUs: "About Us",
  aboutSoEnergy: "About So Energy",
  reviews: "Customer Reviews",
  news: "News & Views",
  careers: "Work for So",
  ourEnergy: "Our Energy",
  smartMeterBooking: "Smart Meter Booking",
  warmHomeDiscount: "Warm Home Discount",
  getSupport: "Get Support",
  energySaving: "Energy Saving Tips",
  unhappy: "Unhappy with Us?",
  emergency: "Emergency",
  priceCap: "Price Cap",
  troubleshooting: "IHD Troubleshooting",
  help: "Help",
  products: "Products",
  solar: "Solar",
  homeCover: "Home Cover",
  smartMeters: "Smart Meters",
  renewal: "Renewal",
  allProducts: "All Products",
  profile: "Profile",
  rewards: "Offers & Rewards",
  flexMarketSubscription: "So Charged",
  evChargers: "EV Chargers",
  evCharging: "EV Charging",
} as const

export const NATIVE_NAV_LABELS = {
  home: "Home",
  readings: "Readings",
  bills: "Bills",
  usage: "Usage",
  chat: "Chat",
} as const

export type NavLabel = (typeof NAV_LABELS)[keyof typeof NAV_LABELS]
export type NativeNavLabel =
  (typeof NATIVE_NAV_LABELS)[keyof typeof NATIVE_NAV_LABELS]
